import React from 'react';
import MenuContainer from './style';
import MenuClose from '../MenuClose';
import { useSelector } from 'react-redux';

function MenuProfile() {
  const { userInfo } = useSelector((state) => state.userSign);

  return (
    <MenuContainer>
      <MenuClose nameProfile={userInfo && userInfo.name} />
    </MenuContainer>
  );
}

export default MenuProfile;
